import { Button } from "@/components/Button"
import { Expense3DSPassword } from "@/components/Cards/Create/Expense/3DSPassword"
import { ExpenseDeliveryAddress } from "@/components/Cards/Create/Expense/DeliveryAddress"
import { ExpensePinCode } from "@/components/Cards/Create/Expense/PinCode"
import { CardsCreateHeader } from "@/components/Cards/Create/Header"
import { Checkbox } from "@/components/Form/Checkbox"
import { Input } from "@/components/Form/Input"
import { useCardCreate } from "@usher/pe-client-front-end-lib"
import { useState } from "react"
import { FormProvider } from "react-hook-form"
import { FormattedMessage, useIntl } from "react-intl"
import { useHistory } from "react-router-dom"
import { CardDetails } from "./card-details"

export const CardCreateExpense = () => {
  const { $t: t } = useIntl()
  const history = useHistory()
  const [check1] = useState(true)
  const [check2, setCheck2] = useState(false)
  const [check3, setCheck3] = useState(false)
  const onSuccess = () => {
    // @ts-ignore
    history.push(`/cards/create/select-payment?bin=${formMethods.getValues().card_bin.value}`)
  }
  const { onSubmit, formMethods, allowPhoneAndPin, isVirtual, isVertex } = useCardCreate({
    onSuccess,
  })
  return (
    <div>
      <CardsCreateHeader subtitle={t({ id: "expenses" })} description={t({ id: "mastercard" })} />
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)} className="container max-w-[500px] !px-0" noValidate autoComplete="off">
          <div className="mb-[33px]">
            <Input.Form control={formMethods.control} name="username" required placeholder={t({ id: "username" })} className="mb-2.5" />
            <Input.Form control={formMethods.control} name="nickname" placeholder={t({ id: "nickname" })} className="mb-2.5" />
          </div>
          <CardDetails formMethods={formMethods} />
          {!isVirtual && allowPhoneAndPin && (
            <>
              <div className="mt-2.5">
                <ExpensePinCode control={formMethods.control} isVertex={isVertex} />
                <div className="mt-8">
                  <ExpenseDeliveryAddress control={formMethods.control} />
                </div>
              </div>
            </>
          )}
          {isVirtual && allowPhoneAndPin && <Expense3DSPassword control={formMethods.control} isVertex={isVertex} />}

          <Checkbox
            checked={check2}
            onChange={(e) => setCheck2(e.target.checked)}
            label={
              <span>
                <FormattedMessage
                  id="term2"
                  values={{
                    b: (chunk) => (
                      <a
                        className="text-main-main"
                        target="_blank"
                        href={process.env.REACT_APP_PATH_HOME + "legal/terms-of-use-for-cards"}
                        rel="noreferrer"
                      >
                        {chunk}
                      </a>
                    ),
                  }}
                />
              </span>
            }
            className="mt-10"
          />
          <Checkbox checked={check3} onChange={(e) => setCheck3(e.target.checked)} label={t({ id: "term3" })} className="py-3 mb-4" />
          <div className="flex flex-col-reverse sm:flex-row sm:child:flex-1 mt-[40px] gap-2.5">
            <Button back variant="outlined" className="w-full" to="/cards">
              <FormattedMessage id="go-back" />
            </Button>
            <Button disabled={!check1 || !check2 || !check3} type="submit">
              <FormattedMessage id="next" />
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  )
}
